(() => {
  function getProductAnalytics(prodInfo, event) {
    const $product = $(`[data-product-box][data-id="${prodInfo.productId}"]`);
    const propsArray = [
      'upgradeFromName',
      'upgradeFromId',
      'listName',
      'listPosition',
      'addToCartDate',
    ];
    const prodAnalytics = {
      id: prodInfo.productId,
      groupId: prodInfo.groupId || '',
      name: prodInfo.name,
      category: prodInfo.category,
      categoryNameId: prodInfo.categoryNameId || 'N/A',
      subCategory: prodInfo.subcategory || 'N/A',
      manufacturer: prodInfo.manufacturer || 'N/A',
      availability: prodInfo.stockState || 'N/A',
      ribbon: TrackApp.getRibbon(prodInfo),
      listName: TrackApp.getListName($product),
      listPosition: $product.closest('article').index() + 1,
      price: Math.round((prodInfo.price / ua.VAT) * 100) / 100,
      packageSKU: prodInfo.packageSKU,
      quantity: prodInfo.quantity,
    };

    if (event === 'cartAdd') {
      TrackApp.addCustomProperties(prodInfo, prodAnalytics, propsArray);
    }
    return prodAnalytics;
  }

  function setEventListeners() {
    $(document).on('uaPushChanges', (e, data) => {
      const { event, isMultiple, prodInfo } = data;

      if (isMultiple) {
        const products = [];
        prodInfo.forEach((prod) => {
          const product = getProductAnalytics(prod, event);
          products.push(product);
        });
        dataLayer.push({
          event: 'cartAddMultiple',
          products,
        });
      } else {
        const product = getProductAnalytics(prodInfo, event);
        dataLayer.push({
          event,
          product,
        });
      }
    });
  }

  function initTrackApp() {
    if (TrackApp.disabled) return;

    setEventListeners();

    if (document.createEvent) {
      const event = document.createEvent('Event');
      event.initEvent('analyticsLoaded', true, false);
      document.dispatchEvent(event);
    } else {
      document.dispatchEvent(new window.CustomEvent('analyticsLoaded'));
    }

    if (App.settings.monitorProductImpressions) {
      TrackApp.initMonitorProductImpressions();
    }

    if (TrackApp.promoTracking) {
      TrackApp.promoTracking.init();
    }

    if (App.settings.userAuthenticated) {
      TrackApp.trackUserData();
    }
  }

  function getDependencies(success) {
    const paths = ['tracking-cart.min.js'];
    if (App.settings.monitorProductImpressions) {
      paths.push('tracking-monitor-product-impressions.min.js');
    }
    if (App.settings.userAuthenticated) {
      paths.push('tracking-user-data.min.js');
    }
    if (TrackApp.subscriptionInOrder) {
      paths.push('tracking-subscription-order.min.js');
    }
    App.require({ paths, success });
  }

  window.TrackApp.init = () => {
    if (TrackApp.disabled) return;
    getDependencies(initTrackApp);
  };
})();
